export default {
  white: '#ffffff',
  black: '#000000',
  fontRegular: 'Apoc Regular, sans-serif',
  fontItalic: 'Apoc Revelations, sans-serif',
  inverseTrans: '0.35s ease-in-out',
};